import React from "react";
import { connect } from "react-redux";
import { getters } from "Portal/ApplicationForm/model";
import { Div } from "components/Base";
import { getIsEditing } from "../selectors";

const decorate = connect(state => ({
  closeAt: getters.closeAt(state),
  isClosed: getters.isClosed(state),
  isEditing: getIsEditing(state)
}));

const CloseAt = ({ closeAt, isClosed, isEditing }) => {
  return isClosed || closeAt ? (
    <Div bg="gray1" bra={2} p={3} mb={3} display="row.center.center">
      {isClosed
        ? isEditing
          ? "Edits to your submission are no longer being accepted"
          : "Submissions are no longer being accepted"
        : isEditing
        ? `Edits to your submission will be accepted until ${closeAt}`
        : `Submissions will be accepted until ${closeAt}`}
    </Div>
  ) : null;
};

export default decorate(CloseAt);
